import { render, staticRenderFns } from "./SupplierProducts.vue?vue&type=template&id=3ce4a164&scoped=true"
import script from "./SupplierProducts.vue?vue&type=script&lang=js"
export * from "./SupplierProducts.vue?vue&type=script&lang=js"
import style0 from "./SupplierProducts.vue?vue&type=style&index=0&id=3ce4a164&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce4a164",
  null
  
)

export default component.exports